import { render, staticRenderFns } from "./home.view.vue?vue&type=template&id=0963a3d7&"
import script from "./home.view.vue?vue&type=script&lang=js&"
export * from "./home.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports